import React from 'react'

function Service() {
  return (
    <>
   
  
   <div class="container relative flex flex-col justify-between h-full xl:px-10 mx-auto mt-5">
  <h2 class="mb-1 text-3xl font-bold leading-tight text-gray-900 font-serif">Services</h2>
  <p class="mb-12 text-lg text-gray-500 font-serif">
    Explore our comprehensive range of services designed to help your business thrive in the digital world.
  </p>

  <div class="w-full grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-2 gap-6 items-stretch">

    {/* <!-- Digital Marketing --> */}
    <div class="relative bg-white border-2 border-indigo-500 rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 h-full">
      <span class="absolute top-0 left-0 w-full h-full mt-1 ml-1 bg-indigo-500 rounded-xl -z-10"></span>
      <h3 class="text-xl font-bold text-gray-800">Digital Marketing</h3>
      <p class="mt-3 mb-1 text-xs font-medium text-indigo-500 uppercase">------------</p>
      <p class="text-gray-600">
        Our Digital Marketing services encompass SEO, social media marketing, content marketing, 
        and analytics to enhance your online visibility. We employ strategic approaches to ensure your 
        business reaches its target audience effectively, increases engagement, and drives meaningful conversions.
        Whether it's organic growth or paid campaigns, we tailor our solutions to align with your business goals.
      </p>
    </div>

    {/* <!-- Website Designing --> */}
    <div class="relative bg-white border-2 border-purple-500 rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 h-full">
      <span class="absolute top-0 left-0 w-full h-full mt-1 ml-1 bg-purple-500 rounded-xl -z-10"></span>
      <h3 class="text-xl font-bold text-gray-800">Website Designing</h3>
      <p class="mt-3 mb-1 text-xs font-medium text-purple-500 uppercase">------------</p>
      <p class="text-gray-600">
        Our expert team designs visually appealing, responsive, and user-friendly websites that align 
        with your brand identity. We focus on UI/UX, functionality, and performance optimization to 
        create websites that captivate visitors and encourage engagement. Our designs are mobile-friendly 
        and SEO-optimized to help you stay ahead of the competition.
      </p>
    </div>

    {/* <!-- Domain Registration --> */}
    <div class="relative bg-white border-2 border-blue-400 rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 h-full">
      <span class="absolute top-0 left-0 w-full h-full mt-1 ml-1 bg-blue-400 rounded-xl -z-10"></span>
      <h3 class="text-xl font-bold text-gray-800">Domain Registration</h3>
      <p class="mt-3 mb-1 text-xs font-medium text-blue-400 uppercase">------------</p>
      <p class="text-gray-600">
        Secure your unique web address with our hassle-free domain registration services. We offer a wide range of domain extensions and help you choose the best name that represents your brand effectively.
      </p>
    </div>

    {/* <!-- Web Hosting --> */}
    <div class="relative bg-white border-2 border-yellow-400 rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 h-full">
      <span class="absolute top-0 left-0 w-full h-full mt-1 ml-1 bg-yellow-400 rounded-xl -z-10"></span>
      <h3 class="text-xl font-bold text-gray-800">Web Hosting</h3>
      <p class="mt-3 mb-1 text-xs font-medium text-yellow-400 uppercase">------------</p>
      <p class="text-gray-600">
        Our web hosting services provide fast, reliable, and secure hosting solutions to keep your website up and running 24/7. We offer scalable plans with features such as unlimited bandwidth, daily backups, and security monitoring.
      </p>
    </div>

    {/* <!-- Messaging & Email Services --> */}
    <div class="relative bg-white border-2 border-green-500 rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 h-full">
      <span class="absolute top-0 left-0 w-full h-full mt-1 ml-1 bg-green-500 rounded-xl -z-10"></span>
      <h3 class="text-xl font-bold text-gray-800">Messaging & Email Services</h3>
      <p class="mt-3 mb-1 text-xs font-medium text-green-500 uppercase">------------</p>
      <p class="text-gray-600">
        Stay connected with your audience through our reliable messaging and email services. We provide bulk SMS, transactional emails, promotional campaigns, and automated notifications to help you engage effectively.
      </p>
    </div>

    {/* <!-- WhatsApp Services --> */}
    <div class="relative bg-white border-2 border-[#e710ea] rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 h-full">
      <span class="absolute top-0 left-0 w-full h-full mt-1 ml-1 bg-[#e710ea] rounded-xl -z-10"></span>
      <h3 class="text-xl font-bold text-gray-800">WhatsApp Services</h3>
      <p class="mt-3 mb-1 text-xs font-medium text-[#e710ea] uppercase">------------</p>
      <p class="text-gray-600">
        At Bulk SMS Nagpur, we offer advanced WhatsApp Messaging solutions to help you connect with your audience in a powerful and engaging way. Our services include bulk WhatsApp messaging, multimedia content sharing (images, videos, and documents), and automated chatbot solutions. 
        Deliver your messages directly to customers' WhatsApp inboxes for higher open rates and better engagement.
      </p>
    </div>

  </div>
</div>

    </>
  )
}

export default Service